<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            {{roleid == 2 ? "Department of Agri Product Sale and Marketing/ Market Plan" : "DPP Branch/ Market Plan"}}
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 2 || roleid == 3">
        <b-tab-item label="ຕະຫຼາດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ລາຍການຕະຫຼາດ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ຊື່ຕະຫຼາດ
                      </th>
                      <th class="has-text-left " width="15%">
                        ແຂວງ
                      </th>
                      <th class="has-text-left " width="15%">
                        ເມືອງ
                      </th>
                      <th class="has-text-left " width="15%">
                        ບ້ານ
                      </th>
                      <th class="has-text-left " width="15%">
                        ລໍຖ້າຢືນຢັນ/ <br>ສົ່ງໂຄຕ້າແລ້ວ
                      </th>
                      <th class="has-text-left " width="30%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in activemarkets" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.MARTKETNAME }}
                      </td>
                      <td>
                        {{ data.PROVINCENAME }}
                      </td>
                      <td>
                        {{ data.DISTRICT }}
                      </td>
                      <td>
                        {{ data.VILLAGE }}
                      </td>
                      <td  class="has-text-centered">
                       {{data.COUNTPREDATE}}/{{data.COUNTSENTDATE}}
                      </td>

                      <td class="has-text-centered">
                        <b-field group>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                gotomarketquotadetailform(data.ID, data.MARTKETNAME)
                              "
                              >ກຳນົດໂຄຕາ
                            </b-button>
                          </b-field>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-info"
                              size="is-small"
                              @click="
                                gotoquotaToProduction(data.ID, data.MARTKETNAME)
                              "
                              >ໂຄຕ້າທີ່ສົ່ງຜະລິດ
                            </b-button>
                          </b-field>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="ຟອມໂຄຕ້າ">
          <b-field v-if="marketname === null">
            <button class="button is-info" @click="gotomarketlist">
              ເລື່ອກຕະຫຼາດ
            </button>
          </b-field>
          <b-field v-else>
            <div class="container">
              <div class="columns">
                <div class="column">
                  <h3 class="title">{{ marketname }}</h3>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field v-if="isActiveQuotaForm" label="ຟອມໂຄຕ້າ"></b-field>
                  
                </div>
                <div class="column">
                  <b-field v-if="isActiveQuotaForm">
                    <b-button
                      class="btn-group-margin"
                      type="is-primary"
                      @click="preQuotalList()"
                      >ເປີດລາຍການລໍຖ້າສົ່ງໂຄຕ້າ ({{prequota}} ວັນ)
                    </b-button>
                  </b-field>
                  <b-field v-if="!isActiveQuotaForm">
                    <b-button
                      class="btn-group-margin"
                      type="is-primary"
                      @click="openQuotaForm()"
                      >ເປີດຟອມໂຄຕ້າ
                    </b-button>
                  </b-field>
                  
                </div>
              </div>
              <b-field v-if="!isActiveQuotaForm">
                <div class="columns">
                  <div class="column">
                    <h3 class="subtitle-bold">ວັນທີລໍຖ້າຢືນຢັນ</h3>
                    <table class="table is-fullwidth is-narrow is-small">
                      <thead>
                        <tr>
                          <th class="has-text-centered " width="5%">#</th>
                          <th class="has-text-left " width="15%">
                            ວັນທີ
                          </th>
                          <th class="has-text-right" width="15%">
                            ຈຳນວນສິນຄ້າ
                          </th>
                          <th class="has-text-right" width="15%">
                            ລາຍລະອຽດ
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(data, index) in preQuotaList" :key="data.REDATE">
                          <td class="has-text-centered">{{ index + 1 }}</td>
                          <td>
                              {{data.REDATE}}
                          </td>
                          <td class="has-text-right">
                            {{data.COUNTPRODUCT}}
                          </td>
                          <td class="has-text-right">
                            <b-button
                            class="btn-group-margin"
                            type="is-primary"
                            size="is-small"
                            @click="openPreQuotaDetail(data.REDATE)"
                            >ລາຍລະອຽດ - {{data.STATUS}}
                          </b-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="column">
                    <b-field v-if="isPreQuotaDetail">
                    <div class="container">
                      <div class="columns">
                      <div class="column">
                        <h3 class="subtitle-bold">ລາຍລະອຽດ ວັນທີ {{selectedRedate}}</h3>
                        
                        <table class="table is-fullwidth is-narrow is-small">
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="5%">#</th>
                              <th class="has-text-left " width="15%">
                                ສິນຄ້າ
                              </th>
                              <th class="has-text-right" width="15%">
                                ຈຳນວນ
                              </th>
                              <th class="has-text-right" width="15%">
                                ຈັດການ
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(data, index) in preQuotaProductList" :key="data.ID">
                              <td class="has-text-centered">{{ index + 1 }}</td>
                              <td>
                                  {{data.PRODUCTNAME}}
                              </td>
                              <td class="has-text-right">
                                {{data.AMOUNT}} {{data.UNIT}}
                              </td>
                              <td class="has-text-right">
                                <b-button
                                class="btn-group-margin"
                                type="is-danger"
                                size="is-small"
                                @click="unSetProductAmount(data.PRODUCTID)"
                                >ຍົກເລີກ
                              </b-button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <b-field group>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-info"
                              size="is-small"
                              @click="setAllProductsToProduction()"
                              >ຢືນຢັນທັງໝົດ
                            </b-button>
                          </b-field>
                            <b-field>
                              <b-button 
                                class="btn-group-margin"
                                type="is-danger"
                                size="is-small"
                                @click="unSetAllProducts()"
                                >ຍົກເລີກທັງໝົດ 
                              </b-button>
                            </b-field>
                            
                        </b-field>
                      </div>
                      </div>
                    </div>   
                    </b-field>
                  </div>
                </div>
                
              </b-field>
              <b-field v-if="isActiveQuotaForm">
              <div class="container">
                <div class="columns">
                  <div class="column">
                    <b-field class="group">
                      <b-field label="ວັນທີ" style="margin-right: 15px;"> </b-field>
                      <b-field>
                        <b-datepicker
                          :date-formatter="dateFormatter"
                          v-model="selecteddate"
                          @input="onSelecteddate"
                        >
                        </b-datepicker>
                      </b-field>
                    </b-field>
                  </div>
                </div>
                
                
                <b-tabs v-model="activeSubTab">
                    <b-tab-item
                    :label="type.TYPENAME"
                    v-for="type in productType"
                      :key="type.TYPEID"
                  >
                    <div class="columns">
                      <div class="column has-text-right">
                          ສິນຄ້າ
                        </div>
                        <div class="column">
                          ຈຳນວນ
                        </div>
                        <div class="column">
                          ຫົວໜ່ວຍ
                        </div>
                        <div class="column"></div>
                        <div class="column"></div>
                        <div class="column"></div>
                      </div>

                      <div :label="type.TYPENAME">
                        <b-field v-for="product in products" :key="product.PRODUCTID">
                          <div class="columns" v-if="type.TYPEID === product.TYPEID">
                            <div class="column has-text-right">
                              {{ product.PRODUCTNAME }}
                            </div>
                            <div class="column">
                              <b-field v-if="product.MRAMOUNT === null">
                                <b-input v-model.trim="product.AMOUNT"> </b-input>
                              </b-field>
                              <b-field v-else>
                                <b-input
                                  v-model.trim="product.MRAMOUNT"
                                  disabled="disabled"
                                >
                                </b-input>
                              </b-field>
                            </div>
                            <div class="column">
                              <b-field group>
                                <b-field>
                                  {{ product.UNIT }}
                                </b-field>
                              </b-field>
                            </div>
                            <div class="column">
                              <b-field group>
                                <b-field
                                  v-if="product.MRSTATUS == 2"
                                  style="margin: 0 10px 0 10px; color: red"
                                >
                                  ສົ່ງຜະລິດແລ້ວ
                                </b-field>
                              </b-field>
                            </div>

                            <div class="column"></div>
                          </div>
                        </b-field>
                      </div>

                      <div class="columns">
                        <div class="column"></div>

                        <div class="column">
                          <b-field group>
                            <b-field>
                              <b-button
                                class="btn-group-margin"
                                type="is-primary"
                                size="is-small"
                                @click="saveProductAmount()"
                                >ບັນທືກ
                              </b-button>
                            </b-field>
                            <b-field>
                              <b-button
                                class="btn-group-margin"
                                type="is-warning"
                                size="is-small"
                                @click="unSetProductsAmount(type.TYPEID)"
                                >ລ້າງໂຄຕາ
                              </b-button>
                            </b-field>
                            <!-- <b-field>
                              <b-button
                                class="btn-group-margin"
                                type="is-info"
                                size="is-small"
                                @click="setProductsToProduction(type.TYPEID)"
                                >ສົ່ງຜະລິດ
                              </b-button>
                            </b-field> -->
                          </b-field>
                        </div>

                        <div class="column"></div>
                        <div class="column"></div>
                      </div>
                    </b-tab-item>
                </b-tabs>
              </div>
              </b-field>
            </div>
          </b-field>
        </b-tab-item>

        <b-tab-item label="ຂຶ້ນແຜນ ແລະ ຕິດຕາມການຜະລິດ">
          <b-field v-if="marketname === null">
            <button class="button is-info" @click="gotomarketlist">
              ເລື່ອກຕະຫຼາດ
            </button>
          </b-field>
          <b-field v-else>
            <div class="container">
              <div class="columns">
                <div class="column">
                  <h3 class="title">{{ marketname }} - {{ quotadate != null ? dateFormatter(quotadate) : ''}}</h3>
                </div>
              </div>
              <b-tabs v-model="activeQuotaSubTab">
                <b-tab-item  label="ຂຶ້ນແຜນຕາມວັນທີ"> 
                  <div class="columns scrollme">
                    <div class="column">
                      <b-field >
                        <table class="table is-fullwidth is-narrow is-small">
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="5%">#</th>
                              <th class="has-text-left " width="15%">
                                ວັນທີ
                              </th>
                              <th class="has-text-right" width="15%">
                                ຈຳນວນປະເພດ
                              </th>
                              <th class="has-text-right" width="15%">
                                ຈຳນວນສິນຄ້າ
                              </th>
                              <th class="has-text-centered" width="20%">
                                ຈັດການ
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(data, index) in quotaltoproduction" :key="data.REDATE">
                              <td class="has-text-centered">{{ index + 1 }}</td>
                              <td>
                                <a @click='quotadatededtailtab(data.REDATE)'>{{ dateFormatter(data.REDATE) }}</a>
                              </td>
                              <td class="has-text-right">
                                {{ data.COUNTTYPE }}
                              </td>
                              <td class="has-text-right">
                                {{ data.COUNTPRODUCT }}
                              </td>
                              <td class="has-text-centered">
                                <a @click='quotadatededtailtab(data.REDATE)'>
                                  <b-button
                                    class="btn-group-margin"
                                    type="is-info"
                                    size="is-small"
                                  
                                    >ຂຶ້ນແຜນ Farmer
                                  </b-button>
                                </a> 

                                <a @click='productiondatededtailtab(data.REDATE)'>
                                  <b-button
                                    class="btn-group-margin"
                                    type="is-primary"
                                    size="is-small"
                                  
                                    >ຕິດຕາມການຜະລິດ
                                  </b-button>
                                </a> 
                              </td>
                              
                            </tr>
                          </tbody>
                        </table>
                      </b-field>
                    </div>
                  </div>
                </b-tab-item>
                <b-tab-item  label="ຂຶຶ້ນແຜນໃຫ້ Farmer"> 
                  <b-field v-if="quotadate === null">
                    <button class="button is-info" @click="gotoquotadate">
                      ເລື່ອກວັນທີ
                    </button>
                  </b-field>
                  <b-field v-else>
                    <div class="container">
                      <!-- <b-field label="ວັນທີ" style="margin-right: 15px;"> </b-field>
                      <b-field>
                        <b-datepicker
                          :date-formatter="dateFormatter"
                          v-model="selectedquotaddate"
                          @input="onSelectedquotaldate"
                        >
                        </b-datepicker>
                      </b-field> -->
                      <b-field v-for="quotadatetype in quotadatetypes" :key="quotadatetype.TYPEID">
                        
                        
                          <div class="column">
                            {{ quotadatetype.TYPENAME }}
                      
                              <table class="table is-fullwidth is-narrow is-small">
                                <thead>
                                  <tr>
                                    <th class="has-text-centered " width="5%">#</th>
                                    <th class="has-text-left " width="5%">
                                      ສິນຄ້າ
                                    </th>
                                    <th class="has-text-right " width="10%">
                                      ຍັງເຫຼືອ/ໂຄຕ້າ
                                    </th>
                                    <th class="has-text-centered " width="5%">
                                      ຈຳນວນ
                                    </th>
                                    <th class="has-text-centered " width="60%">
                                      ຈັດການ
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(quotadateproduct, index) in quotadateproducts" :key="quotadateproduct.PRODUCTID" >
                                    <td class="has-text-centered" v-if="quotadatetype.TYPEID === quotadateproduct.TYPEID">{{ index + 1 }}</td>
                  
                                    <td v-if="quotadatetype.TYPEID === quotadateproduct.TYPEID">
                                      {{quotadateproduct.PRODUCTNAME}}
                                    </td>
                                    <td v-if="quotadatetype.TYPEID === quotadateproduct.TYPEID" class="has-text-right ">
                                      {{quotadateproduct.REMAINAMOUNT}}/{{quotadateproduct.AMOUNT}} {{quotadateproduct.UNIT}}
                                    </td>
                                    <td v-if="quotadatetype.TYPEID === quotadateproduct.TYPEID"  class="has-text-centered ">
                                        <!-- <b-field group>
                                          <b-field
                                            v-if="quotadateproduct.STATUS == 2"
                                            style="margin: 0 10px 0 10px; color: red"
                                          >
                                            ຂຶ້ນແຜນໂຄຕ້າແລ້ວ
                                          </b-field>
                                          <b-field
                                            v-if="quotadateproduct.STATUS != 2"
                                            style="margin: 0 10px 0 10px; color: red"
                                          >
                                            ບໍ່ທັນຖືກກຳນົດ
                                          </b-field>
                                      </b-field> -->
                                      <b-field v-if="quotadateproduct.REMAINAMOUNT> 0">
                                        <b-input v-model.trim="quotadateproduct.REMAINAMOUNTFORUSE" > </b-input>
                                      </b-field>

                                      <span v-if="quotadateproduct.PROSTATUS ==3" style="color: red; font-weight: bold">
                                          ຢືນຢັນ<br>ທັງໝົດແລ້ວ
                                      </span>
                                      <b-field v-if="quotadateproduct.PROSTATUS== 1">
                                            <b-button v-if="quotadateproduct.PROSTATUS ==1"
                                              class="btn-group-margin"
                                              type="is-danger"
                                              size="is-small"
                                  @click="actionToMarketPlanForFarmer(quotadateproduct, 0)"
                                              >ຍົກເລີກ
                                            </b-button>
                                        </b-field>
                                        <b-field v-if="quotadateproduct.PROSTATUS== 1 ">
                                <b-button
                                  v-if="quotadateproduct.PROSTATUS == 1"
                                              class="btn-group-margin"
                                              type="is-primary"
                                              size="is-small"
                                  @click="actionToMarketPlanForFarmer(quotadateproduct, 2)"
                                              >ຢືນຢັນ
                                </b-button>
                                        </b-field>
                                      
                                    </td>
                                    <td v-if="quotadatetype.TYPEID === quotadateproduct.TYPEID" >
                                      
                                            <span v-html="quotadateproduct.FARMERNAME"></span>
                                      
                                        <Multiselect
                                          placeholder="ເລືອກຊາວກະສິກອນ"
                                          v-model.trim="quotadateproduct.selectedFarmer" 
                                          label="FARMERNAME"
                                          track-by="FARMERID"
                                          :options="farmerList"
                                          @input="onSelectedFarmer(quotadateproduct)"
                                        >
                                        </Multiselect>
                                    </td>
                                    
                                  </tr>
                                </tbody>
                              </table>
                            <!-- <b-field class="columns" v-if="type.TYPEID === product.TYPEID">
                              </b-field> -->
                          </div>
                        
                      </b-field>
        
                    </div>
                  </b-field>

                </b-tab-item>

                <b-tab-item  label="ຕິດຕາມການຜະລິດ"> 
                  <b-field v-if="quotadate === null">
                    <button class="button is-info" @click="gotoquotadate">
                      ເລື່ອກວັນທີ
                    </button>
                  </b-field>
                  <b-field v-else>
                    <div class="container">
                      <b-field v-for="quotadatetype in quotadatetypes" :key="quotadatetype.TYPEID">
                          <div class="column">
                            {{ quotadatetype.TYPENAME }}
                      
                              <table class="table is-fullwidth is-narrow is-small">
                                <thead>
                                  <tr>
                                    <th class="has-text-centered " width="5%">#</th>
                                    <th class="has-text-left " width="5%">
                                      ສິນຄ້າ
                                    </th>
                                    <th class="has-text-right " width="5%">
                                    ຈຳນວນ
                                    </th>
                                    <th class="has-text-centered " width="15%">
                                    ຂຶ້ນແຜນເມື່ອ
                                    </th>
                                    <th class="has-text-centered " width="50%">
                                      ຊາວກະສິກອນ/ ຟາມ
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(dateproduction, index) in dateproductions" :key="dateproduction.PRODUCTID" >
                                    <td class="has-text-centered" v-if="quotadatetype.TYPEID === dateproduction.TYPEID">{{index+1}}</td>
                  
                                    <td v-if="quotadatetype.TYPEID === dateproduction.TYPEID">
                                      {{dateproduction.PRODUCTNAME}}
                                    </td>
                                    <td v-if="quotadatetype.TYPEID === dateproduction.TYPEID" class="has-text-right ">
                                      {{dateproduction.AMOUNT}} {{dateproduction.UNIT}}
                                    </td>
                                    <td v-if="quotadatetype.TYPEID === dateproduction.TYPEID"  class="has-text-centered ">
                                      
                                    {{dateproduction.GETPLANDATE}}
                                      
                                    </td>
                                    <td v-if="quotadatetype.TYPEID === dateproduction.TYPEID"  class="has-text-left ">
                                      <!-- {{dateproduction.FARMID}} + -->
                                      <b-field v-for="farmer in farmerProductionList" :key="farmer.FARMID">
                                        <!-- {{dateproduction.ID}} --- {{farmer.MARKETREQUESTID}} -->
                                        <div class="" v-if="dateproduction.ID === farmer.MARKETREQUESTID">
                                          <b-button
                                            class="btn-group-margin"
                                            type="is-primary"
                                              size="is-small"
                                              @click="farmerProduction(farmer.PROID)"
                                              >ລາຍລະອຽດ
                                        </b-button>
                                          {{farmer.FARMERNAME}} ({{farmer.AMOUNT}} {{dateproduction.UNIT}})
                                        </div>
                                      </b-field>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                          </div>
                        
                      </b-field>
        
                    </div>
                  </b-field>

                </b-tab-item>
                <b-tab-item  label="ລາຍລະອຽດການຜະລິດ"> 
                  <b-field v-if="quotadate === null">
                    <button class="button is-info" @click="gotoquotadate">
                      ເລື່ອກວັນທີ
                    </button>
                  </b-field>
                  <b-field v-else>
                    <div class="container">
                      <div class="columns">
                        <b-field v-if="isActiveQuotaForm" class="subtitle-bold">
                          {{farmerProductionFarmername}}
                        </b-field>
                      </div>
                      <div class="columns" >
                        <table class="table is-fullwidth">
                          <tr>
                            <td width="30%" class="has-text-right">
                              <div class="has-text-left">
                                <div class="text-highlight">ຈັດການການຜະລິດ</div> <br>
                              </div>
                              <div>
                                
                                <b-field class="group">
                                  <!-- <b-field label="ວັນທີ" style="margin-right: 15px;"> </b-field> -->
                                  <b-field>
                                    <b-datepicker
                                      :date-formatter="dateFormatter"
                                      v-model="actionDate"
                                      @input="onSelecteddate"
                                    >
                                    </b-datepicker>
                                  </b-field>
                                  &nbsp;
                                  <b-input v-model.trim="actionAmount" placeholder="ຈຳນວນ"> </b-input>
                                  &nbsp;
                                  <Multiselect
                                    placeholder="ຈັດການ"
                                    v-model.trim="selectedProductionAction" 
                                    label="ACTIONNAME"
                                    track-by="ACTIONID"
                                    :options="productionActionList"
                                    @input="onSelectedProductionAction(selectedProductionAction)"
                                  >
                                  </Multiselect>
                                </b-field>
                              </div>
                              <div>
                                <table class="table is-fullwidth ">
                
                                  <tr>
                                    <th class="has-text-right " width="35%">
                                      ລາຍລະອຽດ 
                                    </th>
                                    <th class="has-text-left " width="65%">
                                      
                                    </th>
                                    
                                  </tr>
                            
                                <tbody>
                                  <tr>
                                    
                                    <td class="has-text-right">
                                      ສິນຄ້າ:
                                    </td>
                                    <td class="has-text-left">
                                      <span class="text-highlight"
                                        >{{ farmerProductionProductname }}
                                        {{ farmerProductionAmount }} </span
                                      >/ {{ farmerProductionTotalAmount }}
                                      {{ farmerProductionUnit }} 
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="has-text-right">
                                      ເກັບຜົນຜະລິດຕາມແຜນ: 
                                    </td>
                                    <td class="has-text-left">
                                      <span class="text-highlight">{{farmerProductionRedate}}</span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="has-text-right">
                                      ວັນທີແນະນຳຜະລິດ: 
                                    </td>
                                    <td class="has-text-left">
                                      <span class="text-highlight">{{farmerProductionRecommentdate}}</span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="has-text-right">
                                      ວັນທີຜະລິດຕົວຈິງ: 
                                    </td>
                                    <td class="has-text-left">
                                      <span class="text-highlight">{{farmerProductionProdate}}</span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="has-text-right">
                                      ຈຳນວນທີ່ຜະລິດຕົວຈິງ: 
                                    </td>
                                    <td class="has-text-left">
                                      <span class="text-highlight">{{farmerProductionProamount}} </span> <span v-if="farmerProductionProamount">{{ farmerProductionUnit }}</span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="has-text-right">
                                      ວັນທີເກັບກ່ຽວຕົວຈິງ: 
                                    </td>
                                    <td class="has-text-left">
                                      <span class="text-highlight">{{farmerProductionHarvestdate}}</span>
                                    </td>
                                  </tr>
                                   <tr>
                                    <td class="has-text-right">
                                      ຜົນຜະລິດຕົວຈິງ: 
                                    </td>
                                    <td class="has-text-left">
                                      <span class="text-highlight">{{farmerProductionHarvestamount}} </span> <span v-if="farmerProductionHarvestamount">{{ farmerProductionUnit }}</span>
                                    </td>
                                  </tr>
                                </tbody> 
                              </table>
                              </div>
                                
                            </td>
                            <td width="5%">
                            </td>   
                            <td width="65%">
                              <div class="has-text-left">
                                <div class="text-highlight">ລາຍງານບັນຫາການຜະລິດ</div> <br>
                              </div>
                              <div>
                                 <b-input maxlength="200" v-model.trim="productionReportDetail"  type="textarea" placeholder="ລາຍລະອຽດບັນຫາ"></b-input>
                                <b-field grouped position="is-right">
                                  <b-button
                                    class="btn-group-margin"
                                    type="is-primary"
                                    @click="
                                      productionReport()
                                    "
                                    >ລາຍງານບັນຫາ
                                  </b-button>
                                </b-field>
                              </div>
                                
                              <div>
                                  <table class="table is-fullwidth is-narrow is-small">
                                    <thead>
                                      <tr>
                                        <th class="has-text-left " >
                                          ບັນຫາ
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(data) in productionReportList" :key="data.ID">
                                        <td> 
                                          <div class="container">
                                            <div class="columns">
                                              <div class="column">
                                                <div class="issue-date"><b-field v-if="data.ISFARMER==1">{{ data.ISSUEDATE }} {{ data.ISSUETIME }}</b-field></div>
                                            
                                                <div><b-field v-if="data.ISFARMER==1">{{ data.ISSUE }}</b-field></div>
                                              </div>
                                              <div class="column">
                                                <div class="issue-date issue-response"><b-field v-if="data.ISFARMER!=1">{{ data.ISSUEDATE }} {{ data.ISSUETIME }}</b-field></div>
                                            
                                                <div class="issue-response"><b-field v-if="data.ISFARMER!=1">{{ data.RESPONSE }}</b-field></div>
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr> 
                                    </tbody>
                                  </table>
                              </div>
                            </td>
                            
                          </tr>
                        </table>
                      </div>

                          
                    </div>
                  </b-field>
                </b-tab-item>
              </b-tabs>
            </div>  
          </b-field>
          
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      userName: null,
      roleid: null,
      activemarkets: [],
      inactivemarkets: [],
      marketid: null,
      marketname: null,

      activeTab: 0,
      saveAction: true,
      updateAction: false,
      adddataform: true,
      updatedataform: false,

      activeSubTab: 0,
      productType: [],
      products: [],
      productamount: [],
      selecteddate: null,
      prequota: [],

      quotaltoproduction: [],
      activeQuotaSubTab: 0,
      quotadate: null,
      quotadatetypes: null,
      quotadateproducts: null,
      selectedquotaddate: null,

      dateproductions: [],

      isActiveQuotaForm: true,
      preQuotaList: [],
      isPreQuotaDetail: false,
      preQuotaProductList: [],
      selectedRedate: null,

      farmerList:[],
      marketSelectedDate: null,

      selectedProductionid: null,
      farmerProductionList: [],
      isFarmerProduction: false,
      farmerProductionFarmername: null,
      farmerProductionRequestID: null,
      farmerProductionRedate: null,
      farmerProductionGetplandate: null,
      farmerProductionID: null,
      farmerProductionFarmID: null,
      farmerProductionFarmerID: null,
      farmerProductionTotalAmount: null,
      farmerProductionProductid: null,
      farmerProductionProductname: null,
      farmerProductionUnit: null,
      farmerProductionAmount: null,
      farmerProductionRecommentdate: null,
      farmerProductionProdate: null,
      farmerProductionProamount: null,
      farmerProductionHarvestdate: null,
      farmerProductionHarvestamount: null,
      farmerProductionProstatus: null,
      selectedAction: null,

      actionAmount: 0,
      actionDate: null,
      reportDate: null,
      selectedProductionAction: null,
      productionActionList: [{"ACTIONID":"0", "ACTIONNAME":"ເລືອກ"},{"ACTIONID":"1", "ACTIONNAME":"ເລີ່ມຜະລິດ"}, {"ACTIONID":"2", "ACTIONNAME":"ເກັບກ່ຽວ"}],
      productionReportDetail: null,
      productionReportList: [],

    };
  },
  methods: {
    onSelectedProductionAction(action){
      this.selectedAction = action ? action : this.selectedAction;
      if(action.ACTIONID==0){
        this.$swal("ກະລູນາເລືອກໃຫ້ຖືກຕ້ອງ", "", "error");
      }else if(this.actionAmount == 0 ||  this.actionAmount === null || this.actionAmount==' '){
         this.$swal("ກະລູນາປ້ອນຈຳນວນ", "", "error");
      }
      else if((action.ACTIONID == 1 && this.farmerProductionProstatus =='2') || (action.ACTIONID == 2 && this.farmerProductionProstatus =='3')){
        // console.log("this.selectedFarmer: " + JSON.stringify(this.selectedFarmer));
        console.log("actionid: " + this.actiondate)
        console.log("status: "+ this.farmerProductionProstatus)
        var params = {
          productionid: this.selectedProductionid,
          actionid: action.ACTIONID,
          actiondate: this.dateFormatterYYYYMMDD(this.actionDate),
          amount: this.actionAmount,
          username: this.username
        };
        RestAPI.productionAction(params)
          .then(() => {
            this.farmerProduction(this.selectedProductionid);
            
            this.$swal("ສຳເລັດ !", "", "success");
          })
          .catch(error => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
        
      }
      else{
         this.$swal("ບໍ່ສາມາດດຳເນີນການໄດ້", "", "error");
         this.farmerProduction(this.selectedProductionid);
      }

      
      
    },
    productionReport(){
      if(this.productionReportDetail === null || this.productionReportDetail==' '){
         this.$swal("ກະລູນາ ລະບຸບັນຫາ", "", "error");
      }else{
        // this.selectedProductionid
        console.log("productionReport: " + this.productionReportDetail);

        var params = {
          productionid: this.selectedProductionid,
          detail: this.productionReportDetail,
          // reportDate: this.dateFormatterYYYYMMDD(this.reportDate),
          username: this.username
        };
        
        RestAPI.productionReport(params)
        .then(() => {
          this.farmerProduction(this.selectedProductionid);
          this.getProductionReport(this.selectedProductionid);
          this.productionReportDetail= null;
          this.$swal("ສຳເລັດ !", "", "success");
        })
        .catch(error => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
      }
      
    },

    getProductionReport(productionid) {
      RestAPI.getProductionReport(productionid)
        .then(res => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.productionReportList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    saveForm() {
      // console.log("this.selectedProvince.ID: " + this.selectedProvince.length)
      if (
        this.marketname === null ||
        this.selectedProvince === null ||
        this.district === null ||
        this.village === null
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else {
        var params = {
          marketname: this.marketname,
          provinceid: this.selectedProvince.ID,
          district: this.district,
          village: this.village,
          username: this.username
        };
        RestAPI.saveMarket(params)
          .then(res => {
            // console.log("data: " + JSON.stringify(res.data))
            if (res.data == "duplicate marketname") {
              this.$swal("ຊື່ຕະຫຼາດຊ້ຳ", "-", "error");
              return false;
            }

            this.$swal("ສ້າງຕະຫຼາດ ສຳເລັດ!", "", "success");

            this.activeTab = 2;
            this.saveAction = true;
            this.updateAction = false;
            this.marketname = null;
            this.selectedProvince = null;
            this.district = null;
            this.village = null;
            this.getMarkets();
            this.activeTab = 1;
            // console.log(res);
          })
          .catch(error => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    getMarkets() {
      RestAPI.getMarkets(this.roleid, this.username)
        .then(res => {
          console.log("list:"+ JSON.stringify(res.data))
          this.activemarkets = res.data.activemarkets;
          this.inactivemarkets = res.data.inactivemarkets;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getProductType() {
      RestAPI.getProductType()
        .then(res => {
          this.productType = res.data.activeProductType;
          // console.log("prodcuttype: " + JSON.stringify(this.productType));
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getProducts() {
      RestAPI.getProducts(
        this.marketid,
        this.dateFormatterYYYYMMDD(this.selecteddate)
      )
        .then(res => {
          this.products = res.data;
          // console.log("products: " + JSON.stringify(this.products));
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getProductsMarketPreQuotaDateCount() {
      RestAPI.getProductsMarketPreQuotaDateCount(
        this.marketid
      )
        .then(res => {
          this.prequota = res.data[0].REDATE;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    preQuotalList(){
      this.isActiveQuotaForm = false;
       RestAPI.preMarketQuotalList(
        this.marketid
      )
      .then(res => {
        this.preQuotaList = res.data;
      })
      .catch(error => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },
    openQuotaForm(){
       this.isActiveQuotaForm = true;
       this.preQuotaProductList = null;
    },
    openPreQuotaDetail(redate){
      this.selectedRedate = redate;
      this.isPreQuotaDetail = true;      
      RestAPI.preMarketQuotaProductList(
        this.marketid, redate
      )
      .then(res => {
        this.preQuotaProductList = res.data;
      })
      .catch(error => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },
    gotomarketquotadetailform(ID, MARTKETNAME){
      this.activeTab = 1;
      this.quotaToProduction(ID, MARTKETNAME);
      this.marketquotadetailform(ID, MARTKETNAME);
    },
    marketquotadetailform(ID, MARTKETNAME) {
      this.marketid = ID;
      this.marketname = MARTKETNAME;
      this.getProducts();
      this.getProductsMarketPreQuotaDateCount();
      this.quotaToProduction(ID,MARTKETNAME)
      // console.log("marketid: " + this.marketid);
      // console.log("redate: " + this.dateFormatterYYYYMMDD(this.selecteddate));
    },
    gotomarketlist() {
      this.activeTab = 0;
      this.activeSubTab = 0;
      this.activeQuotaSubTab = 0;
    },
    gotoquotaToProduction(ID,MARTKETNAME){
      this.activeTab = 2;
      this.activeQuotaSubTab = 0;
      this.quotaToProduction(ID, MARTKETNAME);
      this.marketquotadetailform(ID, MARTKETNAME);
      this.getFarmerList();
    },
    quotaToProduction(ID, MARTKETNAME){
      this.marketid = ID;
      this.marketname = MARTKETNAME;
      
      RestAPI.getProductToProduction(this.marketid)
        .then(res => {
          this.quotaltoproduction = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    gotoquotadate() {
      this.activeQuotaSubTab = 0;
    },

    getFarmerList(){
      // console.log("ok: " , this.userProvinceID)
      RestAPI.getFarmerList(this.userProvinceID)// ແລ້ວອັບເດດເປັນ branchid ແລະ ໄປຊອກໃນ ຶ branchprovinces
        .then(res => {
          this.farmerList = res.data;
          console.log("farmerlist: " + JSON.stringify(this.farmerList))
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getFarmerProductionList(){
      // console.log("ok: " , this.userProvinceID)
      RestAPI.getFarmerProductionList(this.userProvinceID, this.quotadate)
        .then(res => {
          this.farmerProductionList = res.data;
          console.log("farmerProductionList: " + JSON.stringify(this.farmerProductionList))
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    onSelectedFarmer(data){
      //console.log("data-: " + JSON.stringify(data))
      if (
        data.REMAINAMOUNTFORUSE === null ||
        data.REMAINAMOUNTFORUSE == 0 || !data.REMAINAMOUNTFORUSE
      ) {
        this.$swal("ກະລູນາປ້ອນຈຳນວນ", "", "error");
      }
      else if(data.REMAINAMOUNTFORUSE>data.REMAINAMOUNT){
        this.$swal("ຈຳນວນທີ່ປ້ອນ ເກີນຈຳນວນຍັງເຫຼ່ືອ", "", "error");
      }
      else{
          this.$swal({
            title: "ຕ້ອງການຈັດແຜນໃຫ້ຊາວກະສິກອນ ແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6"
          }).then(result => {
             if (result.value) {
              var params = {
              requirementid: data.ID,
              amount: data.REMAINAMOUNTFORUSE,
              productid: data.PRODUCTID,
              farmerid: data.selectedFarmer.FARMERID,
              farmid: data.selectedFarmer.FARMID,
              username: this.username
             };
            console.log("params: ", JSON.stringify(params))
            RestAPI.setMarketPlanForFarmer(params)
              .then((res) => {
                this.$swal("ຈັດແຜນໃຫ້ຊາວກະສິກອນ ສຳເລັດ!", "", "success");
                 console.log("res: ", JSON.stringify(res.data))
                this.quotadatededtailtab(data.REDATE)
                // this.getDppContractProductList(this.activePlanYear);
              })
              .catch(error => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
              });
            }
          });
      }
    },

    actionToMarketPlanForFarmer(data,status){     
      this.$swal({
        title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6"
      }).then(result => {
        if (result.value) {
          var params = {
          requirementid: data.ID,
          status: status,
          username: this.username
        };
        RestAPI.actionToMarketPlanForFarmer(params)
          .then(() => {
            console.log("pararm: "+ params)
            this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
            this.quotadatededtailtab(data.REDATE)
          })
          .catch(error => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
        }
      });

    },

    farmerProduction(productionid){
      RestAPI.getfarmerProduction(productionid)
      .then(res => {
        this.getProductionReport(productionid);
        // console.log("farmerProduction:"+ JSON.stringify(res.data))
        // this.activemarkets = res.data.activemarkets;
        // this.inactivemarkets = res.data.inactivemarkets;
        this.selectedProductionid = productionid;
        // console.log("data: " + JSON.stringify(farmer))
        // console.log("dateproduction: " + JSON.stringify(dateproduction))
        this.farmerProductionFarmername =  res.data[0].FARMERNAME;
        this.farmerProductionRequestID =  res.data[0].MARKETREQUESTID;
        this.farmerProductionID =  res.data[0].PROID;
        this.farmerProductionRedate =  res.data[0].REDATE;
        this.farmerProductionGetplandate =  res.data[0].GETPLANDATE;
        this.farmerProductionFarmID =  res.data[0].FARMID
        this.farmerProductionFarmerID =  res.data[0].FARMERID
        this.farmerProductionTotalAmount =  res.data[0].TOTALAMOUNT;
        this.farmerProductionProductid =  res.data[0].PRODUCTID;
        this.farmerProductionProductname =  res.data[0].PRODUCTNAME;
        this.farmerProductionUnit =  res.data[0].UNIT;
        this.farmerProductionAmount =  res.data[0].AMOUNT;
        this.farmerProductionRecommentdate =  res.data[0].RECOMMENTPRODUCEDATE;
        this.farmerProductionProdate =  res.data[0].PRODUCEDATE;
        this.farmerProductionProamount =  res.data[0].PRODUCEAMOUNT;
        this.farmerProductionHarvestdate =  res.data[0].HARVESTDATE;
        this.farmerProductionHarvestamount =  res.data[0].HARVESTAMOUNT;
        this.farmerProductionProstatus =  res.data[0].PROSTATUS;

        this.activeQuotaSubTab = 3;
        this.isFarmerProduction = true; 
      })
      .catch(error => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
      
    },
    
    onSelecteddate() {
      this.getProducts();
      // this.formdate = this.dateFormatterYYYYMMDD(this.selecteddate);
      // console.log(this.formdate);
    },

    onSelectedquotaldate() {
      this.quotadatededtailtab(this.dateFormatterYYYYMMDD(this.selectedquotaddate))
      console.log("this.dateFormatterYYYYMMDD(this.selectedquotaddate): " + this.dateFormatterYYYYMMDD(this.selectedquotaddate))
    },
    saveProductAmount() {
      //  console.log("this.formdate: "+ this.formdate)
      var params = {
        redate: this.dateFormatterYYYYMMDD(this.selecteddate),
        marketid: this.marketid,
        products: this.products,
        username: this.username
      };

      // console.log("params: ", JSON.stringify(params))

      RestAPI.saveProductAmount(params)
        .then(() => {
          this.$swal("ບັນທືກ ສຳເລັດ!", "", "success");
          this.getProducts();
        })
        .catch(error => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    unSetAllProducts() {
      //  console.log("this.formdate: "+ this.formdate)
      var params = {
        redate: this.dateFormatterYYYYMMDD(this.selectedRedate),
        marketid: this.marketid,
        username: this.username
      };

      RestAPI.unSetAllProducts(params)
        .then(() => {
          this.$swal("ລ້າງໂຄຕ້າ ສຳເລັດ!", "", "success");
          this.preQuotalList()
          this.openPreQuotaDetail(this.selectedRedate)
          this.getProducts();
        })
        .catch(error => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    unSetProductsAmount(type) {
      //  console.log("this.formdate: "+ this.formdate)
      var params = {
        redate: this.dateFormatterYYYYMMDD(this.selectedRedate),
        marketid: this.marketid,
        typeid: type,
        username: this.username
      };

      RestAPI.unSetProductsAmount(params)
        .then(() => {
          this.$swal("ລ້າງໂຄຕ້າ ສຳເລັດ!", "", "success");
          this.getProducts();
          // this.preQuotalList()
          // this.openPreQuotaDetail(this.selectedRedate)
        })
        .catch(error => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    unSetProductAmount(productid) {
      //  console.log("this.formdate: "+ this.formdate)
      var params = {
        redate: this.dateFormatterYYYYMMDD(this.selectedRedate),
        marketid: this.marketid,
        productid: productid,
        username: this.username
      };
      console.log("params: " + JSON.stringify(params))

      RestAPI.unSetProductAmount(params)
        .then(() => {
          this.$swal("ລ້າງໂຄຕ້າ ສຳເລັດ!", "", "success");
          this.preQuotalList()
          this.openPreQuotaDetail(this.selectedRedate)
          // this.getProducts();
        })
        .catch(error => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    setAllProductsToProduction(){
      var params = {
        marketid: this.marketid,
        redate: this.dateFormatterYYYYMMDD(this.selectedRedate),
        username: this.username
      };

      console.log("par: "+ JSON.stringify(params))

      RestAPI.setAllProductsToProduction(params)
        .then(() => {
          this.$swal("ສົ່ງຜະລິດ ສຳເລັດ!", "", "success");
          this.preQuotalList()
          this.openPreQuotaDetail(this.selectedRedate)
        })
        .catch(error => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    setProductsToProduction(typeid){
      var params = {
        typeid: typeid,
        redate: this.dateFormatterYYYYMMDD(this.selecteddate),
        username: this.username
      };

      console.log("par: "+ JSON.stringify(params))

      RestAPI.setProductsToProduction(params)
        .then(() => {
          this.$swal("ສົ່ງຜະລິດ ສຳເລັດ!", "", "success");
          this.getProducts();
        })
        .catch(error => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    setProductToProduction(mrid) {
      //  console.log("this.formdate: "+ this.formdate)
      var params = {
        mrid: mrid,
        username: this.username
      };

      RestAPI.setProductToProduction(params)
        .then(() => {
          this.$swal("ສົ່ງຜະລິດ ສຳເລັດ!", "", "success");
          this.getProducts();
        })
        .catch(error => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    quotadatededtailtab(redate){
      console.log("redate: "+ redate)
      this.quotadate = redate; 
      this.activeQuotaSubTab = 1;
      RestAPI.getquotadatededtail(this.marketid, this.quotadate)
        .then(res => {
          this.quotadatetypes = res.data.quotadatetypes;
          this.quotadateproducts = res.data.quotadateproducts;
          console.log("quotadateproducts: "+ JSON.stringify(this.quotadateproducts[0]))
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });

    },

    productiondatededtailtab(redate){
      console.log("redate: "+ redate)
      this.quotadate = redate; 
      this.activeQuotaSubTab = 2;
      RestAPI.getquotadatededtail(this.marketid, this.quotadate)
        .then(res => {
          this.quotadatetypes = res.data.quotadatetypes;
          this.dateproductions = res.data.dateproductions;
          this.getFarmerProductionList();
          // console.log("quotadateproducts: "+ JSON.stringify(this.quotadateproducts[0]))
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    
    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    print() {
      window.print();
    }
  },
  mounted() {
    console.log("this.user.BRANCHPROVNICEID: " + JSON.stringify(this.user));
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.userProvinceID = this.user.BRANCHPROVNICEID;
    this.getMarkets();
    this.getProductType();
    this.selecteddate = new Date();
    this.actionDate = new Date();
    this.reportDate = new Date();
    this.selectedquotaddate = new Date();
    this.formdate = new Date();
  },
  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
